import { render } from "./DataQualityStatusBarTooltip.vue?vue&type=template&id=6855476f&ts=true"
import script from "./DataQualityStatusBarTooltip.vue?vue&type=script&lang=ts"
export * from "./DataQualityStatusBarTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__